<template>
  <div class="collaborator default-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12" style="text-align: center">
                  <h3>Seja nosso colaborador</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div v-html="page.content" class="text-content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'collaborator',
  data() {
    return {
      page: {}
    };
  },
  mounted() {
    this.getPageContent();
  },
  methods: {
    getPageContent: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/content_pages_public/3`)
        .then(response => {
          this.page = response.data;
        });
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>